import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputHelperTextComponent } from 'app/shared/components/input-helper-text/input-helper-text.component';
import { TranslateFieldValueComponent } from 'app/shared/components/translate-field-value/translate-field-value.component';
import { HelperService } from 'app/shared/services/helper.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-input-form-field',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, TranslateFieldValueComponent, InputHelperTextComponent],
  templateUrl: './input-form-field.component.html',
  styleUrl: './input-form-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputFormFieldComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputFormFieldComponent),
      multi: true,
    }
  ],
})
export class InputFormFieldComponent implements ControlValueAccessor, OnInit, OnDestroy {
  @Input() label: string = '';
  @Input() type: string = 'text';
  @Input() placeholder: string = 'placeholders.type_text_here';
  @Input() isRequired: boolean = false;
  @Input() infoText: string = '';
  @Input() viewMode!: boolean;
  @Input() errorText: string = '';
  @Input() patternText: string = '';
  @Input() isLabelTopPosition: boolean = false;
  @Input() translatable: boolean = true;
  @Input() helpText!: string;
  @Output() onChangeEvent = new EventEmitter<string>();

  inlineEditMode!: boolean;
  formControl: FormControl = new FormControl<string>('');
  translated: string = '';

  private unsubscribe$ = new Subject<void>();

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private helperService: HelperService
  ) {}

  onTouch: () => void = () => {};
  onChange: (value: any) => void = () => {};

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    isDisabled ? this.formControl.disable() : this.formControl.enable();
  }

  writeValue(value: string): void {
    this.formControl.setValue(value, { emitEvent: false });

    this.changeDetectorRef.markForCheck();
  }

  ngOnInit(): void {
    this.formControl.valueChanges
      .pipe(
        takeUntil(this.unsubscribe$)
      )
      .subscribe((value) => {
        this.onChange(value);
      });
  }

  onChangeValue(data: any) {
    this.onChangeEvent.emit(data?.target?.value);
  }

  validate(control: FormControl) {
    setTimeout(() => {
      this.errorText = this.helperService.handleFieldsErrors(control, this.patternText);
      this.changeDetectorRef.markForCheck();
    });
    return null;
  }

  translate(event: string) {
    this.translated = event;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}


